import _asyncToGenerator from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/regenerator/index.js";
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

import AuthSdkError from '../errors/AuthSdkError.js';
import '../errors/WWWAuthError.js';
import { btoa as b } from '../crypto/browser.js';
import { toQueryString } from '../util/url.js';
import { post } from '../http/request.js';
import 'tiny-emitter';
import 'js-cookie';
import 'cross-fetch';
import { getOAuthUrls } from './util/oauth.js';
function revokeToken(_x, _x2) {
  return _revokeToken.apply(this, arguments);
}
function _revokeToken() {
  _revokeToken = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(sdk, token) {
    var accessToken, refreshToken, clientId, clientSecret, revokeUrl, args, creds;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          accessToken = '';
          refreshToken = '';
          if (token) {
            accessToken = token.accessToken;
            refreshToken = token.refreshToken;
          }
          if (!(!accessToken && !refreshToken)) {
            _context.next = 5;
            break;
          }
          throw new AuthSdkError('A valid access or refresh token object is required');
        case 5:
          clientId = sdk.options.clientId;
          clientSecret = sdk.options.clientSecret;
          if (clientId) {
            _context.next = 9;
            break;
          }
          throw new AuthSdkError('A clientId must be specified in the OktaAuth constructor to revoke a token');
        case 9:
          revokeUrl = getOAuthUrls(sdk).revokeUrl;
          args = toQueryString({
            token_type_hint: refreshToken ? 'refresh_token' : 'access_token',
            token: refreshToken || accessToken
          }).slice(1);
          creds = clientSecret ? b("".concat(clientId, ":").concat(clientSecret)) : b(clientId);
          return _context.abrupt("return", post(sdk, revokeUrl, args, {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
              'Authorization': 'Basic ' + creds
            }
          }));
        case 13:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _revokeToken.apply(this, arguments);
}
export { revokeToken };